module.exports = __webpack_public_path__ + "img/22.f345a2a3.png";